var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.btnClass,attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.handleClick}},[_vm._t("icon"),_vm._v("\n  "+_vm._s(_vm.value)+"\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }